"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
const Pageshow_1 = __importDefault(require("@web/common/Pageshow"));
class PriceSwitch {
    static init() {
        if (this.priceSwitchInput === null) {
            return;
        }
        this.priceSwitchInput.addEventListener('change', () => {
            var _a;
            const showPricesWithVat = ((_a = this.priceSwitchInput) === null || _a === void 0 ? void 0 : _a.checked) === false;
            this.setCookie(showPricesWithVat);
            this.setDisplayVatClass(showPricesWithVat);
        });
    }
    static refresh() {
        const showPricesWithVat = js_cookie_1.default.get(this.pricesWithVatCookieName) === '1';
        if (this.priceSwitchInput) {
            this.priceSwitchInput.checked = !showPricesWithVat;
        }
        this.setDisplayVatClass(showPricesWithVat);
    }
    static setCookie(showPricesWithVat) {
        if (showPricesWithVat) {
            this.sendGtmPriceVatDisplaySwitchEvent('with-vat');
            js_cookie_1.default.set(this.pricesWithVatCookieName, '1', {
                sameSite: 'lax',
                secure: true,
            });
        }
        else {
            this.sendGtmPriceVatDisplaySwitchEvent('without-vat');
            js_cookie_1.default.remove(this.pricesWithVatCookieName);
        }
    }
    static sendGtmPriceVatDisplaySwitchEvent(selectedVatDisplayType) {
        (0, GtmDataLayer_1.default)({
            event: 'price_display_vat_switch',
            eventLabel: selectedVatDisplayType,
        });
    }
    static setDisplayVatClass(showPricesWithVat) {
        if (showPricesWithVat) {
            document.documentElement.classList.remove('displayWithoutVat');
            document.documentElement.classList.add('displayWithVat');
        }
        else {
            document.documentElement.classList.add('displayWithoutVat');
            document.documentElement.classList.remove('displayWithVat');
        }
    }
}
PriceSwitch.priceSwitchInput = document.getElementById('price-switch-input');
PriceSwitch.pricesWithVatCookieName = 'prices_with_vat';
(() => {
    PriceSwitch.init();
    (0, Pageshow_1.default)(() => {
        PriceSwitch.refresh();
    });
})();
